<template>
  <div v-if="project" class="card" tabindex="0">
    <ImageWrapper class="project-img" :denyFullscreen="true" :src="project.thumbnailUrl"
      :alt="project.title || 'project'" />
    <div class="info">
      <div class="project-info">
        <p>{{ project.thumbTitle }}</p>
        <p>{{ project.publishedAt.split('-')[0] }}</p>
      </div>
      <CategoriesBar :selectedCategories="project.categories" />
    </div>
  </div>

</template>

<style scoped>
.card {
  position: relative;
  width: 270px;
  height: 190px;
  overflow: hidden;
  cursor: pointer;
}

:deep(.image-wrapper-img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity 0.2s ease;
}

.info {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.2s ease;
  background: var(--background-color);
  color: var(--primary-text-color);
  align-items: end;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 39.75px;
}

.project-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 10px;
  line-height: 12px;
}

.card:hover .project-img,
.card:focus .project-img {
  opacity: 0;
}

.card:hover .info,
.card:focus .info {
  opacity: 1;
}
</style>

<script setup>
import ImageWrapper from '../atoms/image-wrapper.vue';
import CategoriesBar from './categories-bar.vue';

const props = defineProps({ project: Object })
</script>
